import React, { useEffect, useRef, useState } from 'react'
import DataTable from '../../component/data_table/DataTable'
import AddButton from '../../component/buttons/AddButton';
import { Link, useNavigate } from 'react-router-dom';
import { userListRes, userListTodo } from '../../redux/slices/user/UserList';
import { useDispatch, useSelector } from 'react-redux';
import { CircleX, FilePenLine, LockKeyhole, Trash2 } from 'lucide-react';
import Swal from 'sweetalert2';
import { res, deleteUserTodo } from '../../redux/slices/user/DeleteUser';
import { toast, ToastContainer } from 'react-toastify';
import Loader from '../../component/loader/Loader';
import { Tooltip } from 'react-tooltip';
import UpdatePsw from '../login/UpdatePsw';
import SingleSelect from '../../component/input_filed/SingleSelect';
import SaveButton from '../../component/buttons/SaveButton';
import { Button, Form } from 'react-bootstrap';
import { designationListTodo } from '../../redux/slices/master/designation/DesignationList';
import { departmentListTodo } from '../../redux/slices/master/department/DepartmentList';
import { useFormik } from 'formik';

export default function UserList() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [bool, setBool] = useState(false)
    const [show, setShow] = useState(false)
    const [userData, setUserData] = useState('')
    const [loading, setLoading] = useState(false)
    const [filterLoad, setFilterLoad] = useState(false)
    const userList = useSelector(state => state?.userList?.data?.data)
    const designationList = useSelector(state => state?.designationList?.data?.data)
    const departmentList = useSelector(state => state?.departmentList?.data?.data)

    // console.log(userList)

    const designation_option = designationList?.map(val => (
        { "value": val?._id, "label": val?.name }
    ))

    const department_option = departmentList?.map(val => (
        { "value": val?._id, "label": val?.name }
    ))

    const status_option = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' }
    ];

    const roleList = [
        { value: 'admin', label: 'Admin' },
        { value: 'engineer', label: 'Engineer' },
        { value: 'operator', label: 'Operator' },
        { value: 'viewer', label: 'Viewer' },
    ];


    useEffect(() => {
        setLoading(true)
        Promise.all([
            dispatch(userListTodo({ navigate })),
            dispatch(designationListTodo({ navigate, status: 'Active' })),
            dispatch(departmentListTodo({ navigate, status: 'Active' })),
        ]).finally(() => setLoading(false));
    }, [bool])



    const editUser = (data) => {
        navigate('/update-user', { state: data })
    }


    const passwordUpdate = (data) => {
        setShow(true)
        setUserData(data)
    }

    const deleteUser = (data) => {
        Swal.fire({
            title: "User Delete",
            text: 'Are you sure want to delete',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Confirm'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteUserTodo(data)).then((res) => del_res(res))
            }
        })
    }

    const del_res = (res) => {
        if (res?.payload?.status == 204) {
            setBool(!bool)
            Swal.fire({
                title: 'User',
                text: res?.massage,
                icon: 'success',
                confirmButtonText: 'OK'
            })

        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        } else if (res?.payload?.status == 404) {
            toast.error('Not Found', { position: "bottom-right" });
        } else {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }

    // FILTER CODE----------------------------------

    const initiaValues = {
        role: '',
        department: '',
        designation: '',
        status: '',
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initiaValues,

        onSubmit: (values, action) => {
            setFilterLoad(true)
            dispatch(userListTodo({ navigate, values })).then(() => filter_res())

        }
    })

    const filter_res = () => {
        if (userListRes?.status) {
            setFilterLoad(false)
        } else {
            setFilterLoad(false)
        }
    }
    const roleRef = useRef();
    const statusRef = useRef();
    const designationRef = useRef();
    const departmentRef = useRef();

    const handleReset = () => {
        // roleRef.current.clearValue();
        statusRef.current.clearValue();
        designationRef.current.clearValue();
        departmentRef.current.clearValue();
        setBool(!bool)
    };


    const columnDefs = [
        {
            headerName: 'S.NO',
            maxWidth: 90,
            valueGetter: 'node.rowIndex + 1',
            filter: false,
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 70
        },
        {
            headerName: 'IMAGE',
            field: 'profile_image',
            cellRenderer: (params) =>
                params?.value ? (
                    <img
                        src={process.env.REACT_APP_IMAGE_URL + `/${params.value}` || ''}
                        alt={params?.data?.name || 'gate'}
                        style={{ height: 40, width: 40, objectFit: 'cover', borderRadius: 4 }}
                        onError={(e) => { e.currentTarget.style.display = 'none' }}
                    />
                ) : null,

            filter: false,
            suppressHeaderMenuButton: true,
            sortable: false,
            floatingFilter: false,
            autoHeight: true,
        },
        {
            headerName: 'NAME',
            field: 'name',
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },
        {
            headerName: 'CONTACT',
            field: 'phone',
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },
        {
            headerName: 'EMAIL',
            field: 'email',
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },

        {
            headerName: 'ROLE',
            field: 'userRole',
            cellRenderer: params => {
                const value = params?.value || '';
                const capitalized = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
                return <span>{capitalized}</span>;
            },
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },
        {
            headerName: 'DEPARTMENT',
            field: 'department.name',
            cellRenderer: params => <span style={{ textTransform: 'capitalize' }}>{params?.value ? params?.value : '-'}</span>,
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },
        {
            headerName: 'DESIGNATION',
            field: 'designation.name',
            cellRenderer: params => <span style={{ textTransform: 'capitalize' }}>{params?.value ? params?.value : '-'}</span>,
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },

        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params =>
                params?.data?.status?.toLowerCase() === 'active'
                    ? <span className='badge text-bg-success'>Active</span>
                    : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 120
        },
        {
            headerName: 'ACTION',
            cellRenderer: params => (
                <div className='d-flex'>
                    <span
                        onClick={() => editUser(params?.data)}
                        data-tooltip-id='edit'
                        data-tooltip-content="User Update"
                        data-tooltip-place="bottom"
                        type='button'
                    >
                        <FilePenLine className='text-success' size={20} />
                    </span>
                    <span className='ms-2'
                        onClick={() => passwordUpdate(params?.data)}
                        data-tooltip-id='password'
                        data-tooltip-content="Password Update"
                        data-tooltip-place="bottom"
                        type='button'
                    >
                        <LockKeyhole className='text-info' size={20} />
                    </span>
                    {/* <span className='ms-2'
                        onClick={() => deleteUser(params?.data?._id)}
                        data-tooltip-id='delete'
                        data-tooltip-content="User Delete"
                        data-tooltip-place="bottom"
                        type='button'
                    >
                        <Trash2 className='text-danger' size={20} />
                    </span> */}
                    <Tooltip id='edit' className='bg-success tooltip_msg' />
                    <Tooltip id='password' className='bg-info tooltip_msg' />
                    <Tooltip id='delete' className='bg-danger tooltip_msg' />
                </div>
            ),
            autoHeight: true,
            pinned: 'right',
            maxWidth: 150
        }
    ];


    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout_head d-flex justify-content-between align-items-center mb-3'>
                            <h5>User List</h5>
                            <Link to='/add-user'>   <AddButton label={"ADD USER"} /> </Link>
                        </div>
                        <Form onSubmit={handleSubmit}>
                            <div className='row justify-content-center'>
                                {/* <div className="col-md-2">
                                    <SingleSelect label_name='' reference={roleRef} option={roleList} name='role'
                                        placeholder={'Role'}
                                        onChange={(e) => setFieldValue('role', e?.value)}
                                        onBlur={handleBlur}
                                        error={''}
                                    />
                                </div> */}
                                <div className="col-md-2">
                                    <SingleSelect label_name='' reference={departmentRef} option={department_option} name='department'
                                        placeholder={'Department'}
                                        onChange={(e) => setFieldValue('department', e?.value)}
                                        onBlur={handleBlur}
                                        error={''}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <SingleSelect label_name='' reference={designationRef} option={designation_option} name='designation'
                                        placeholder={'Designation'}
                                        onChange={(e) => setFieldValue('designation', e?.value)}
                                        onBlur={handleBlur}
                                        error={''}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <SingleSelect label_name='' reference={statusRef} option={status_option} name='status'
                                        placeholder={'Status'}
                                        onChange={(e) => setFieldValue('status', e?.value)}
                                        onBlur={handleBlur}
                                        error={''}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <SaveButton name={'FILTER'} />
                                    <Button type='button' onClick={handleReset} variant="" className='save_btn ms-2'><CircleX /></Button>
                                </div>
                            </div>
                        </Form>
                        {loading || filterLoad ?
                            <div className='text-center'>
                                <Loader />
                            </div>
                            :
                            <DataTable
                                rowData={userList}
                                columnDefs={columnDefs}
                                height={'65vh'}
                            />}
                    </div>
                </div>
            </div>
            <UpdatePsw show={show} setShow={setShow} userData={userData} />
        </>
    )
}
